// extracted by mini-css-extract-plugin
export var bold = "ConfirmModal-module--bold--5a1b1";
export var cancelButton = "ConfirmModal-module--cancel-button--c4643";
export var confirmButton = "ConfirmModal-module--confirm-button--37b60";
export var header = "ConfirmModal-module--header--51742";
export var modalButtons = "ConfirmModal-module--modal-buttons--a05dc";
export var root = "ConfirmModal-module--root--34eca";